import React,{Component} from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import * as routes from './constants/routes';
import { Link, Redirect } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import  ReactLogo from './assets/holidays-logo.svg';
import { withRouter } from 'react-router';
import { AppContext } from './context/applicationContext';
import * as db from './db/db';
import Badge from '@material-ui/core/Badge';
import MailIcon from '@material-ui/icons/Mail';
import NotificationsIcon from '@material-ui/icons/Notifications';
import MoreIcon from '@material-ui/icons/MoreVert';
import BeachAccessIcon from '@material-ui/icons/BeachAccess';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';
import BusinessIcon from '@material-ui/icons/Business';
import AccountCircleRoundedIcon from '@material-ui/icons/AccountCircleRounded';
import WorkIcon from '@material-ui/icons/Work';
import WorkOutlineRoundedIcon from '@material-ui/icons/WorkOutlineRounded';
import Drawer from "@material-ui/core/Drawer";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import HomeRoundedIcon from '@material-ui/icons/HomeRounded';
import InboxIcon from "@material-ui/icons/MoveToInbox";
import ListIcon from '@material-ui/icons/List';
import ViewListRoundedIcon from '@material-ui/icons/ViewListRounded';
import QueueRoundedIcon from '@material-ui/icons/QueueRounded';
import AcUnitIcon from '@material-ui/icons/AcUnit';
import WbSunnyIcon from '@material-ui/icons/WbSunny';
import axios from 'axios';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { withSnackbar } from 'notistack';
import * as statuses from '../src/constants/requestStatus';
const baseUrl = (process.env.PUBLIC_URL==='/'?'': process.env.PUBLIC_URL) ||'';


const styles = theme => ({
    root: {
      flexGrow: 1,
    },
    grow: {
      flexGrow: 1,
    },
    menuButton: {
      marginLeft: -12,
      marginRight: 20,
    },
    appBar: {
      backgroundColor: '#1a5cac'
    },
    layout: {
      width: 'auto',
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      [theme.breakpoints.up(800 + theme.spacing(2 * 2))]: {
        width: 800,
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    },
    paper: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
      padding: theme.spacing(2),
      [theme.breakpoints.up(800 + theme.spacing(3 * 2))]: {
        marginTop: theme.spacing(6),
        marginBottom: theme.spacing(6),
        padding: theme.spacing(3),
      },
      background: 'rgb(255 255 255 / 96%)',
    },
    stepper: {
      padding: `${theme.spacing(3)}px 0 ${theme.spacing(5)}px`,
    },
    buttons: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    button: {
      width: '100%',
      backgroundColor: '#3a3f4b!important'
    },
    icon: {
      color: '#3a3f4b'
    }    
  });
  
class Header extends Component {
    
    static contextType = AppContext;
    constructor(props) {
      super(props);
      this.state = {
        redirect: false, anchorEl: null, userInfo: null, infoEl: null, left: false, redirectToList: false,
        redirectToNewHoliday: false, date: null, approveListDisabled: false, redirectToHolidaysList: false, consentListDisabled: false
      }
    }
  
  componentDidMount() {
    if (this.context.userId !== null) {
      this.setState({ showMenu: true });
      db.idbMethods.get(this.context.userId, db.userInfo).then((userInfo) => {
        if (userInfo && userInfo?.userId !== null && userInfo?.userPrimaryCompany.companyURL !== null && userInfo?.userId !== undefined
          && userInfo.userPrimaryCompany.companyURL !== undefined) {
          this.setState({ userId: userInfo.userId, userSite: userInfo.userPrimaryCompany.companyURL });
          this.getUserData(userInfo.userId, userInfo.userPrimaryCompany.companyURL);
        }
      });
    }
    var today = new Date();
    this.setState({ date: today.getMonth() + 1 });
  }
  
  
    getUserData(id, siteUrl) {
      const link = baseUrl + '/api/getUserData';
      // const isExpire = service.axiosMethods.getNewToken(this.context.expireIn).then((getNew) => {
      // });

      axios.post(link, {
          "SiteUrl": siteUrl,
          "UserId": id
      }, { headers: { 'Authorization': 'Bearer ' + this.context.token } })
          .then(res => {
            if (this.context.userId !== null) {
              this.setState({ showMenu: true });
            }
              if (res.status === 200) {
                //this.props.enqueueSnackbar('Успешен вход!', { variant: "success" });
                  let replacmentsArr = [];
                  res.data.Replacements.forEach(rep => {
                      replacmentsArr.push({ id: rep.UserID, label: rep.FullName });
                  });
                  this.context.setStateCustom('days', res.data.Days);
                  this.context.setStateCustom('daysAdded', res.data.DaysAdded);
                  //this.setState({ redirectToList: true });
                  //this.setState({ fullName: res.data.FullName, employe: res.data, replacementUsers: replacmentsArr, progress: false });
                  db.idbMethods.getAll(db.userInfo).then((userInfo) => {
                    if (userInfo !== undefined || userInfo !== null || userInfo.length !== 0) {
                      var user = res.data;
                   
                      user.userId = userInfo[0].userId;
                      user.Expires = userInfo[0].Expires;
                      user.Token = userInfo[0].Token;
                      user.userPrimaryCompany = userInfo[0].userPrimaryCompany;
                      db.idbMethods.set(user, db.userInfo);
                      this.setState({ userInfo: user });
                      this.context.setStateCustom('days', user.Days);
                      this.context.setStateCustom('daysAdded', user.DaysAdded);
                      var userSites = '';
                      userSites = user.userPrimaryCompany.companyURL + '*';
                      if(user.userSecondaryCompanys){
                      user.userSecondaryCompanys.forEach((company, i) => {
                          userSites = userSites + company.companyURL + '*';
                      });
                     
                    }
                    this.checkAddedDaysForUser(user.userPrimaryCompany.companyURL,user.UserPosition);          
                    this.getHolidaysList(this.context.userId, userSites);
                    }
                  })

                  
        
              }
          }).catch(error => {
              console.log(error);
              var errorObj = JSON.parse(JSON.stringify(error));
              this.logOut();
              this.props.enqueueSnackbar(errorObj.response.data.errorMsg, { variant: "error" });
              this.setState({ redirect: true });
          })
  }  
  
    handleMenu = event => {
      this.setState({ anchorEl: event.currentTarget });
    };
  
    handleInfoMenu = event => {
      this.setState({ infoEl: event.currentTarget });
    };
  
    handleClose = () => {
      this.setState({ anchorEl: null });
      this.setState({ infoEl: null });
    };
  
    logOut = () => {
      this.context.setStateCustom('userId', null);
      db.idbMethods.clear(db.userInfo);
      db.idbMethods.clear(db.holidaysForApprove);
      db.idbMethods.clear(db.holidaysForApproveList);
      db.idbMethods.clear(db.myHolidays);
      this.setState({ redirect: true });
      setTimeout(() => {
        window.location = window.location;
      }, 100);
    }

    getHolidaysList = (id, userSite) => {
      this.setState({ syncProgress: true });
      const link = baseUrl +  '/api/allHolidays';
      axios.post(link, {
          "UserCompanys": userSite,
          "UserId": id,
          "RowLimit": 30
      }, { headers: { 'Authorization': 'Bearer ' + this.context.token } })
          .then(res => {
              if (res.status === 200) {
                  const rows = [];
                  var ids = [];
                  if (res.data !== undefined) {
                      if (res.data !== "") {
                          res.data.forEach((element, i) => {
                              ids.push(element.Id);
                              // if (element.Status === statuses.FOR_CONFIRM) {
                              //     const index = element.Title.indexOf(' №') + 2;
                              //     const url = element.employeeHolidaySiteURL.split('/');
                              //     //const row = createData(element.Id, element.Title.substr(index), element.Status, element.employeeName, this.formatTime(element.DateFrom), this.formatTime(element.DateTo), url[url.length - 2]);
                              //     rows.push(row);
                              // }
                              if (i === res.data.length - 1) {
                                  db.idbMethods.clear(db.holidaysForApprove);
                                  db.idbMethods.set(ids, db.holidaysForApprove);
                                  db.idbMethods.clear(db.holidaysForApproveList);
                                  db.idbMethods.set(res.data, db.holidaysForApproveList);
                                  this.setState({ approveListDisabled: true });
                              }
                          });
                      }
                  }        
                 
                  
                  this.setState({ syncProgress: false });
                  //this.setState({ rows: rows });   
                  // if(rows.length === 0){
                  //     this.setState({ redirect: true });
                  // };        
              }
             
              this.setState({ progress: false });
          }).catch(error => {
              this.setState({ progress: false });
              this.setState({ redirect: true });
              this.setState({ syncProgress: false });
              console.log(error);
              if (error.response != undefined && error.response.status === 401) {
                  this.logOut();
              }
          })
  }

  checkAddedDaysForUser(siteUrl,userPosition) {
    const link = baseUrl + '/api/checkAddedDaysForUser';
    axios.post(link,  {
        "UserId": this.context.userId,
        "UserPosition": userPosition,
        "SiteUrl": siteUrl
    }, { headers: { 'Authorization': 'Bearer ' + this.context.token } })
        .then(res => {
            if (res.status === 200) {
                if (res.data === "OK") {
                this.setState({ useAddedDays: true, progress: false });
                } else{
                this.setState({ useAddedDays: false, progress: false });
                }
            }
        }).catch(error => {
            console.log(error);
           // var errorObj = JSON.parse(JSON.stringify(error));
           // this.props.enqueueSnackbar(errorObj.response.data.errorMsg, { variant: "error" });
           // this.setState({ progress: false,useAddedDays: false });
        })
} 
  
    toggleDrawer = (open) => (event) => {
      if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
      }
  
      this.setState({ left: open });
    };
  
    redirectToHolidaysList = () => {
      this.setState({ redirectToList: true });
    }
    redirectToAddHoliday = () => {
      this.setState({ redirectToNewHoliday: true });
    }
  
    redirectToConfirmHolidaysList = () => {
      this.setState({ redirectToHolidaysList: true });
    }

    componentDidUpdate(prevProps) {
      if (this.props.userData != null && this.state.userInfo === null) {
        this.getUserData(this.props.userData.userId, this.props.userData.userPrimaryCompany.companyURL);
      }
    }
  

    render() {
        if (this.state.redirect) {
          return <Redirect to={routes.HOME_LOGIN} />
        }
        if (this.state.redirectToNewHoliday) {
          return <Redirect to={routes.HOLIDAYS_FORM} />
        }
        if (this.state.redirectToList) {
          return <Redirect to={routes.MY_HOLIDAYS} />
        }
        if (this.state.redirectToList) {
          return <Redirect to={routes.HOLIDAYS} />
        }
        const { classes } = this.props;
        const { anchorEl, infoEl } = this.state;
        const open = Boolean(anchorEl);
        const openInfo = Boolean(infoEl);
    
        return (
          <React.Fragment>
            <CssBaseline />
            <AppBar position="static" style={
              { backgroundColor: '#3a3f4b',  position: 'fixed', marginTop: '0px',top: '0px',left: '0px'}}>
              <Toolbar>
                {this.context.userId !== null && (<IconButton onClick={this.toggleDrawer(true)} className={classes.menuButton} color="inherit" aria-label="Menu">
                  <MenuIcon />
                </IconButton>)}
    
                {/* //from here */}
                <div className={classes.grow} />
                <Typography variant="h6" color="inherit" className={classes.grow}>
                  {/* <img className="img-logo" src={Logo2} /> */}
                  <img src={ReactLogo}  className='logo'/>
                  {/* <img  src={TitleSvg} /> */}
                </Typography>
                
                {this.context.userId !== null && (
                  <div>
    
                    <Menu
                      id="menu-appbar"
                      anchorEl={infoEl}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      open={openInfo}
                      onClose={this.handleClose}
                    >
                      <MenuItem >
                        {this.state.userInfo  ?
                          <span>
                            <Typography variant="body2" color="inherit" className={classes.grow}>
                              Дни отпуск: <span className='bolder'>{this.context.days}</span>
                            </Typography>
                            {/* <Typography variant="body2" color="inherit" className={classes.grow}>
                              Дни доп. отпуск: <span className='bolder'>{this.state.userInfo.DaysAdded}</span>
                            </Typography> */}
                            {/* {this.state.useAddedDays ? */}
                            <Typography variant="body2" color="inherit" className={classes.grow}>
                              Дни доп. отпуск: <span className={this.state.useAddedDays && this.context.daysAdded && this.context.daysAdded > 0 ? 'bolder': 'bolder added-days'}>{this.context.daysAdded}</span>
                              {/* Дни доп. отпуск: <span className={this.state.useAddedDays ? 'bolder': 'bolder added-days'}>{this.state.userInfo.DaysAdded}</span> */}
                            </Typography>
                            {/* : null} */}
                          </span>
                          : null}
                      </MenuItem>
    
                    </Menu>
                    <Menu
                      id="menu-appbar"
                      anchorEl={anchorEl}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      open={open}
                      onClose={this.handleClose}
                    >
                      {this.state.userInfo ? <span>
                        <MenuItem onClick={this.handleClose} className='right-menu-text'>
                          <IconButton className={classes.icon}>
                            <AccountCircleRoundedIcon />
                          </IconButton><span className='menuItem'>{ this.state.userInfo.FullName}</span></MenuItem>
                        <MenuItem onClick={this.handleClose} className='right-menu-text'>
                          <IconButton className={classes.icon}>
                            <WorkOutlineRoundedIcon />
                          </IconButton>
                          <span className='menuItem'>{this.state.userInfo.UserPosition}</span> </MenuItem>
                        <MenuItem onClick={this.handleClose} className='right-menu-text'>
                          <IconButton className={classes.icon}>
                            <BusinessIcon />
                          </IconButton>
                          <span className='menuItem'> {this.state.userInfo.Department} </span></MenuItem>
                        <MenuItem className='white-back-button' onClick={() => { this.logOut() }}>
    
                          <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            onClick={() => { this.logOut() }}
                            className={classes.button}
                          >
                            <ExitToAppIcon className='white-back-button'></ExitToAppIcon>
                            Изход
                             </Button>
    
                        </MenuItem></span>
                        : null}
                    </Menu>
                  </div>
                )}
                <div className={classes.buttons}>
                  <IconButton aria-label="show 4 new mails" color="inherit" onClick={this.handleInfoMenu}>
                    {(this.context.days !== null && this.context.days != undefined) ?
                      <Badge badgeContent={this.context.days + this.context.daysAdded} color="secondary" className="badge">
                        {(this.state.date === 12 || this.state.date === 1) ?
                          <AcUnitIcon /> : ((this.state.date === 7 || this.state.date === 8) ? <BeachAccessIcon /> : <WbSunnyIcon />)}
    
                      </Badge> : null}
                  </IconButton>
                  <IconButton
                    aria-owns={open ? 'menu-appbar' : undefined}
                    aria-haspopup="true"
                    onClick={this.handleMenu}
                    color="inherit"
                  >
                    <AccountCircleIcon />
                  </IconButton>
                </div>
              </Toolbar>
            </AppBar>
            <Drawer anchor='left' open={this.state.left} onClose={this.toggleDrawer(false)}>
              <div
                role="presentation"
                onClick={this.toggleDrawer(false)}
                onKeyDown={this.toggleDrawer(false)}
              >
                <List className={'list'}>
                  <ListItem className='name-background padding-bottom-menu left-menu'>
                    <IconButton >
                      < AccountCircleIcon className='white-icon' fontSize="large" />
                    </IconButton>
                  </ListItem>
                  <ListItem className='name-background left-menu'>
                    {this.state.userInfo ? <span className='white-icon'>{this.state.userInfo.FullName}</span> : null}
    
                    {/* {this.state.userInfo ? <span>{this.state.userInfo.userPrimaryCompany.companyName}</span> : null } */}
                  </ListItem>
                  <ListItem component={Link} to={baseUrl + "/myHolidays"} className='padding-left-menu'>
                    <Button
                      size="small"
                      color="inherit"
                    >
                      <HomeRoundedIcon className={classes.icon}></HomeRoundedIcon>
                      <ListItemText className='menu-link black-color menu-btn-txt' primary='Моите отпуски' />
                    </Button>
                   
                  </ListItem>
                  <ListItem component={Link} to={baseUrl + "/holidays"} className='padding-left-menu' >
                    <Button
                      size="small"
                      color="inherit"
                    >
                      <QueueRoundedIcon className={classes.icon}></QueueRoundedIcon>
                      <ListItemText className='menu-link black-color menu-btn-txt' primary='Добавяне' />
                    </Button>
                    
                  </ListItem>
    
    
                  {this.state.approveListDisabled ?
                    <ListItem component={Link} to={baseUrl + "/allHolidays"} className='padding-left-menu' >
                      <Button
                        size="small"
                        color="inherit"
                      >
                        <ViewListRoundedIcon className={classes.icon}></ViewListRoundedIcon>
                        <ListItemText className='menu-link black-color menu-btn-txt' primary='За одобрение' />
                      </Button>
                      
                    </ListItem>
                    : null}
                  {this.context.consentListDisabled ?
                    <ListItem component={Link} to={baseUrl + "/consentHolidays"} className='padding-left-menu' >
                      <Button
                        size="small"
                        color="inherit"
                      >
                        <ListIcon className={classes.icon}></ListIcon>
                      </Button>
                      <ListItemText className='menu-link black-color' primary='За съгласуване' />
                    </ListItem>
                    : null}
                </List>
              </div>
            </Drawer>
          </React.Fragment>
        );
      }
    
    
}
Header.propTypes = {
    classes: PropTypes.object.isRequired,
  };
    
export default withStyles(styles)(withSnackbar(Header));
